function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "flat"
}, /*#__PURE__*/React.createElement("path", {
  d: "m307.306 437.907-72.106 13.276-88.62-35.874-81.817-77.14a27.9 27.9 0 0 1 -3.836-36.137 27.906 27.906 0 0 1 38.813-7.145l70.947 48.885 118.033-6.819z",
  fill: "#fdc9a6"
}), /*#__PURE__*/React.createElement("path", {
  d: "m296 419-121.3-14.83a28.832 28.832 0 0 1 -25.85-28.74 28.512 28.512 0 0 1 5.12-16.26 28.847 28.847 0 0 1 21.42-12.37l68.2-5.47c.4-.62.8-1.23 1.21-1.84l43.92-2.54z",
  fill: "#e6af89"
}), /*#__PURE__*/React.createElement("path", {
  d: "m240 166c8.836 0 17-8.163 17-17v-35a145.47 145.47 0 0 0 -34 0v35c0 8.837 8.164 17 17 17z",
  fill: "#ea9d2d"
}), /*#__PURE__*/React.createElement("path", {
  d: "m320 161c8.836 0 17-8.163 17-17l1-14.632-2-1.368a216.036 216.036 0 0 0 -32-9.769l-3-.838 2 26.607c0 8.837 8.164 17 17 17z",
  fill: "#ea9d2d"
}), /*#__PURE__*/React.createElement("path", {
  d: "m160 161c8.836 0 17-8.163 17-17v-25.954l-1 .659a216.038 216.038 0 0 0 -32 9.3l-1 .84v15.155c0 8.837 8.164 17 17 17z",
  fill: "#ea9d2d"
}), /*#__PURE__*/React.createElement("path", {
  d: "m381.688 143.256-8.634-5.5a215.9 215.9 0 0 0 -37.054-18.828v25.072a16 16 0 0 1 -32 0v-34.841a215.917 215.917 0 0 0 -46.885-5.159h-1.115v40a16 16 0 0 1 -32 0v-40h-3.928a215.975 215.975 0 0 0 -44.072 4.552v35.448a16 16 0 0 1 -32 0v-26.153a215.915 215.915 0 0 0 -47.767 25.19 56.811 56.811 0 0 0 -24.233 46.543v1.607a56.813 56.813 0 0 0 56.813 56.813h222.375a56.813 56.813 0 0 0 56.812-56.813 56.814 56.814 0 0 0 -26.312-47.931z",
  fill: "#fbb540"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 240,
  cy: 216,
  fill: "#ea9d2d",
  r: 8
}), /*#__PURE__*/React.createElement("circle", {
  cx: 176,
  cy: 216,
  fill: "#ea9d2d",
  r: 8
}), /*#__PURE__*/React.createElement("circle", {
  cx: 144,
  cy: 200,
  fill: "#ea9d2d",
  r: 8
}), /*#__PURE__*/React.createElement("circle", {
  cx: 336,
  cy: 200,
  fill: "#ea9d2d",
  r: 8
}), /*#__PURE__*/React.createElement("circle", {
  cx: 208,
  cy: 200,
  fill: "#ea9d2d",
  r: 8
}), /*#__PURE__*/React.createElement("circle", {
  cx: 272,
  cy: 200,
  fill: "#ea9d2d",
  r: 8
}), /*#__PURE__*/React.createElement("circle", {
  cx: 304,
  cy: 216,
  fill: "#ea9d2d",
  r: 8
}), /*#__PURE__*/React.createElement("g", {
  fill: "#2fbbdf"
}, /*#__PURE__*/React.createElement("path", {
  d: "m48 72a8 8 0 0 1 -8-8v-8a8 8 0 0 1 16 0v8a8 8 0 0 1 -8 8z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m48 120a8 8 0 0 1 -8-8v-8a8 8 0 0 1 16 0v8a8 8 0 0 1 -8 8z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m24 96a8 8 0 0 1 -8-8v-8a8 8 0 0 1 16 0v8a8 8 0 0 1 -8 8z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m72 96a8 8 0 0 1 -8-8v-8a8 8 0 0 1 16 0v8a8 8 0 0 1 -8 8z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m464 248a8 8 0 0 1 -8-8v-8a8 8 0 0 1 16 0v8a8 8 0 0 1 -8 8z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m464 296a8 8 0 0 1 -8-8v-8a8 8 0 0 1 16 0v8a8 8 0 0 1 -8 8z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m440 270.8a8 8 0 0 1 -8-8v-8a8 8 0 0 1 16 0v8a8 8 0 0 1 -8 8z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m488 272a8 8 0 0 1 -8-8v-8a8 8 0 0 1 16 0v8a8 8 0 0 1 -8 8z"
})), /*#__PURE__*/React.createElement("path", {
  d: "m480.946 368.662-86.991-59.94a95.433 95.433 0 0 0 -71.428-15.272l-6.839 1.259a95.435 95.435 0 0 0 -63.154 42.491l-68.2 5.473a28.807 28.807 0 0 0 -21.417 12.369 28.806 28.806 0 0 0 20.73 45l80.964 8.45 42.694 29.417 63.572-19.159 51.233 35.3z",
  fill: "#fdc9a6"
}));

var SvgRequestFoodIcon = function SvgRequestFoodIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgRequestFoodIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/request_food_icon.ef207bef.svg";
export { ForwardRef as ReactComponent };